module.exports = __webpack_public_path__ + "staticesp/media/marcass.9e795d88.jpg";